module.exports = __webpack_public_path__ + "static/media/image-en.c2c235ff.png";